/**
 * Per-kind config for court bond retrieval page shells (Phase 9.9A).
 */
export const BOND_RETRIEVAL_SHELL_CONFIG = {
  va: {
    signIndemnityDisabled: ({ isEsignatureLoading, data, globalState }) =>
      isEsignatureLoading ||
      data?.status === "Active" ||
      globalState?.basicInformation?.is_esignatures === "No" ||
      data?.third_document_url === null,
    showDataCorrectionButton: () => true,
    esignatureButtonLabel: "Trigger Formstack",
    historyUpdatesVariant: "simple",
  },
  trustee: {
    signIndemnityDisabled: ({ isEsignatureLoading, data, globalState }) =>
      isEsignatureLoading ||
      data?.status === "Active" ||
      globalState?.basicInformation?.is_esignatures === "No" ||
      data?.third_document_url === null,
    showDataCorrectionButton: () => true,
    esignatureButtonLabel: "Trigger Formstack",
    historyUpdatesVariant: "simple",
  },
  probate: {
    signIndemnityDisabled: ({ isEsignatureLoading, data, globalState }) =>
      isEsignatureLoading ||
      data?.status === "Active" ||
      globalState?.basicInformation?.is_esignatures === "No" ||
      data?.third_document_url === null,
    showDataCorrectionButton: (role) => role !== "carrier_team_member",
    esignatureButtonLabel: "Trigger Formstack",
    historyUpdatesVariant: "card",
  },
  guardianship: {
    signIndemnityDisabled: ({ isEsignatureLoading, data, globalState }) =>
      isEsignatureLoading ||
      data?.status === "Active" ||
      globalState?.basicInformation?.is_esignatures === "No" ||
      data?.third_document_url === null,
    showDataCorrectionButton: () => true,
    esignatureButtonLabel: "Trigger Formstack",
    historyUpdatesVariant: "card",
  },
};

export function getBondRetrievalShellConfig(kind) {
  const config = BOND_RETRIEVAL_SHELL_CONFIG[kind];
  if (!config) {
    throw new Error(`Unknown bond retrieval shell kind: ${kind}`);
  }
  return config;
}
